export default "__VITE_ASSET__DhZ9zLCb__"